<template>
    <Main>
        <router-view />
    </Main>  
</template>

<script setup lang = "ts" >
    import Main from "@/app/views/app/main.vue";
    import { commClient } from "fw4-library";
    import { useAppStore } from "./store/app/app-store";
    import { useGeneralStore } from "@appstore/general-store";
    import { onMounted, provide } from "vue";
    import { useFw4Store } from "fw4-library";
    import { useRoute } from "vue-router";

    const route = useRoute();
    const appStore = useAppStore();    
    const generalStore = useGeneralStore();

    const authenticationFailed = (): void => {
        console.log("error-auth");
        // router.push({name: "home"});
    };

    window.onbeforeunload = (event) => {
        if (route.name === "WebOrderEnd") {
            return;
        }

        if(appStore.DataHelpers.CloseTab == false){
            event.preventDefault();
            return event.returnValue = "Ste prepričani, da želite zapustiti aplikacijo?";
        }
    }

    onMounted(async () => {
        commClient.OnWebSocketAuthenticationFailed.AddCallback(authenticationFailed);
        try {
            await commClient.connectWebSockets();

            console.log("WebSockets connected.");

            await generalStore.loadCountryLoad();
            await generalStore.postalCodeLoad();
            await generalStore.countryPhoneLoad();
        }
        catch (e) {
            console.error("WebSocket connection or initialization failed.", e);
        }
    });
    const { ExportData, ShowReport } = useFw4Store();

    provide("showReport", ShowReport);
    provide("exportData", ExportData);
    provide("commClient", commClient);
    provide("generalStore", generalStore);
</script>